import { axiosBackoffice } from '../axiosClient';

const useBackofficeAxios = () => {
  return axiosBackoffice;
};

export default useBackofficeAxios;
